/**
 * Detect fn
 */
export default () => 'console' in self
